var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-screen"},[_c('AuthNav'),_c('ResetPasswordForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }